<angular-loader></angular-loader>
<div>
  <router-outlet></router-outlet>
</div>





// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/app.component.html